module.exports = __webpack_public_path__ + "static/media/Mongo.c4001cd9.svg";